import actions from '@ehi/global-marketing-interface/lib/actions';

const { extrasState, extrasUpdate: gmiExtrasUpdate } = actions.reservations;

// Extras Actions
export const extrasUpdate = (extra, quantity) => (dispatch) => {
  dispatch(extrasState.set('extra', { extra, quantity }));
  return dispatch(gmiExtrasUpdate()).then((res) => {
    if (quantity === 0) {
      dispatch(extrasState.unset('extra', extra));
    }
    return res;
  });
};
